import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Button } from '../ui/button';

interface SessionJoinerProps {
  onJoin: (sessionCode: string, nickname: string) => void;
  isLoading: boolean;
  error?: string;
  initialCode?: string;
}

const SessionJoiner: React.FC<SessionJoinerProps> = ({
  onJoin,
  isLoading,
  error,
  initialCode,
}) => {
  const [sessionCode, setSessionCode] = useState(initialCode || '');
  const [nickname, setNickname] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Reset local error
    setLocalError(null);
    
    // Validate inputs
    if (!sessionCode.trim()) {
      setLocalError('Please enter a session code');
      return;
    }
    
    if (!nickname.trim()) {
      setLocalError('Please enter a nickname');
      return;
    }
    
    // Call the join handler
    onJoin(sessionCode.toUpperCase(), nickname);
  };
  
  return (
    <div className="max-w-md mx-auto">
      <Card>
        <CardHeader>
          <CardTitle>Join Session</CardTitle>
        </CardHeader>
        
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium text-foreground">
                Session Code
              </label>
              <input
                type="text"
                className="w-full h-12 px-4 border-2 rounded-lg text-lg font-semibold uppercase text-center tracking-wider bg-white focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all"
                maxLength={6}
                value={sessionCode}
                onChange={(e) => setSessionCode(e.target.value.toUpperCase())}
                placeholder="ABC123"
                disabled={isLoading}
              />
            </div>
            
            <div className="space-y-2">
              <label className="text-sm font-medium text-foreground">
                Your Nickname
              </label>
              <input
                type="text"
                className="w-full h-12 px-4 border-2 rounded-lg text-base bg-white focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all"
                maxLength={20}
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                placeholder="Enter your nickname"
                disabled={isLoading}
              />
            </div>
            
            {(error || localError) && (
              <div className="bg-red-50 border-2 border-red-300 rounded-lg p-3 text-destructive text-sm text-center">
                {error || localError}
              </div>
            )}
            
            <Button 
              type="submit" 
              size="lg"
              className="w-full"
              disabled={isLoading}
            >
              {isLoading ? 'Joining...' : 'Join Quiz'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default SessionJoiner;